import { render, staticRenderFns } from "./StoryCarouselWidgetStory.vue?vue&type=template&id=6730adfa&scoped=true"
import script from "./StoryCarouselWidgetStory.vue?vue&type=script&setup=true&lang=ts"
export * from "./StoryCarouselWidgetStory.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./StoryCarouselWidgetStory.vue?vue&type=style&index=0&id=6730adfa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6730adfa",
  null
  
)

export default component.exports